// extracted by mini-css-extract-plugin
export default {"container":"goals_container__3iFBE","h2":"goals_h2__1g-Tz","OurGoal":"goals_OurGoal__nZf+M"};